module.exports = __webpack_public_path__ + "static/media/bounce_it.248d068b.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/assets/game_icons/bounce_it.png
// module id = 295
// module chunks = 0